export default "__VITE_ASSET__C77MitrK__"